module.exports = __webpack_public_path__ + "img/2d5985c6a63b07de48c3fe8c53fb7a88.png";